import { FC } from 'react';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import GirlStub from '#webImages/girl-stub.webp';
import { useStoryDetailContext } from '#advertStory/detail';
import { PictureForPhoto } from '#advert/components/picture-for-photo';
import storyDetailAdvertAvatarCss from '../../assets/detail/story-detail-advert-avatar.module.scss';

const StoryDetailHeaderAdvertAvatar: FC = () => {
  const { story } = useStoryDetailContext();

  return (
    <Link
      to={story.advert.url}
      state={{ routerConfig: RouterConfig.initForAdvertDetail(story.advert.id) }}
      className={storyDetailAdvertAvatarCss.storyDetailAdvertAvatar}
    >
      <PictureForPhoto
        photo={story.advert.photo}
        stub={GirlStub}
        className={storyDetailAdvertAvatarCss.storyDetailAdvertAvatar__image}
        isUse100
      />
    </Link>
  );
};

export { StoryDetailHeaderAdvertAvatar };
